/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface UserLockoutInfoDto
 */
export interface UserLockoutInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof UserLockoutInfoDto
     */
    userIsLockedOut?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLockoutInfoDto
     */
    lockOutEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserLockoutInfoDto
     */
    failedAccessAttempts?: number;
    /**
     * 
     * @type {number}
     * @memberof UserLockoutInfoDto
     */
    maxFailedAccessAttempts?: number;
    /**
     * 
     * @type {number}
     * @memberof UserLockoutInfoDto
     */
    lockoutDurationSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof UserLockoutInfoDto
     */
    $type?: UserLockoutInfoDtoTypeEnum;
}


/**
 * @export
 */
export const UserLockoutInfoDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationUsersDtoUserLockoutInfoDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserLockoutInfoDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UserLockoutInfoDtoTypeEnum = typeof UserLockoutInfoDtoTypeEnum[keyof typeof UserLockoutInfoDtoTypeEnum];


/**
 * Check if a given object implements the UserLockoutInfoDto interface.
 */
export function instanceOfUserLockoutInfoDto(value?: unknown): value is UserLockoutInfoDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UserLockoutInfoDtoTypeEnum)[0];
}

export function UserLockoutInfoDtoFromJSON(json: any): UserLockoutInfoDto {
    return UserLockoutInfoDtoFromJSONTyped(json, false);
}

export function UserLockoutInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLockoutInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIsLockedOut': !exists(json, 'userIsLockedOut') ? undefined : json['userIsLockedOut'],
        'lockOutEnabled': !exists(json, 'lockOutEnabled') ? undefined : json['lockOutEnabled'],
        'failedAccessAttempts': !exists(json, 'failedAccessAttempts') ? undefined : json['failedAccessAttempts'],
        'maxFailedAccessAttempts': !exists(json, 'maxFailedAccessAttempts') ? undefined : json['maxFailedAccessAttempts'],
        'lockoutDurationSeconds': !exists(json, 'lockoutDurationSeconds') ? undefined : json['lockoutDurationSeconds'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UserLockoutInfoDtoToJSON(value?: UserLockoutInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'userIsLockedOut': value.userIsLockedOut,
        'lockOutEnabled': value.lockOutEnabled,
        'failedAccessAttempts': value.failedAccessAttempts,
        'maxFailedAccessAttempts': value.maxFailedAccessAttempts,
        'lockoutDurationSeconds': value.lockoutDurationSeconds,
        '$type': value.$type,
    });
}

